import { truncate } from "lodash";
import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circle-react/components/shared/uikit/Typography";

interface AttachmentRowProps {
  filename: string;
  url: string;
}

export const AttachmentRow = ({ url, filename }: AttachmentRowProps) => (
  <div className="bg-primary border-primary flex items-center gap-2 break-all rounded-2xl border px-4 py-2">
    <Icon type="hw-paperclip" size={20} className="text-tertiary" />
    <a href={url} target="_blank" rel="noopener noreferrer">
      <Typography.LabelXs weight="medium" color="text-darkest flex">
        {truncate(filename, { length: 52 })}
      </Typography.LabelXs>
    </a>
  </div>
);
